// src/modules/app-views/_apps/appsindico/units/pages/Document/decorators/request.js

const decorateRequest = ctx => {
  const { data } = ctx;
  if (!data) return data;
  return { ...data };
};

export default decorateRequest;
